export const DISMISSED_FG_BANNERS_COOKIE = 'dismissed_fg_banners';

export const ELITE_SPOTS = 5;
export const ELITE_SPOTS_TEXT = 'five';
export const ELITE_TIPPED_SPOTS_TEXT = 'four';

/* not enforced on the backend, just a soft deadline */
export const DAYS_TO_AWARD = 7;

export const MAX_ROUND_FINALISTS = 5;

export const FINAL_ROUND_EXTENSION = 2;

export const FINAL_ROUND_FAQ = (isCreative) => (
  isCreative?
  "/help/working-in-projects/what-is-a-finalist-round-for-creatives/" :
  "/help/managing-project/what-is-a-finalist-round/"
);
